var map = {
	"./bee/themes/dark/banner.svg": [
		9389,
		389
	],
	"./bee/themes/light/banner.svg": [
		9971,
		971
	],
	"./hornet/themes/dark/banner.svg": [
		6740,
		740
	],
	"./hornet/themes/light/banner.svg": [
		8963,
		963
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4469;
module.exports = webpackAsyncContext;